<template>
  <div class="related">
    <div class="app-width-large">
      <LayoutSlider :slides="items" :class="['related__slider', items.length < 3 ? `related__slider--count-${items.length}` : '']">
        <template #slide="{ slide, slideIndex }">
          <UiCardRelated
            :key="`card-${slideIndex}`"
            v-bind="slide"
            class="related__card"
          />
        </template>

        <template #previous="{ enabled }">
          <UiButtonFlat :class="['related__nav', 'related__nav--left', { 'related__nav--enabled': enabled }]" type="left" />
        </template>

        <template #next="{ enabled }">
          <UiButtonFlat :class="['related__nav', 'related__nav--right', { 'related__nav--enabled': enabled }]" type="right" />
        </template>
      </LayoutSlider>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: { type: Array, default: null },
  },
};
</script>

<style lang="stylus" scoped>
$card-size = 504px

:deep(.slider__wrapper) {
  +size(L) {
    overflow hidden
  }
}

:deep(.slider__slide) {
  width 100%
  box-sizing border-box

  +size(L) {
    max-width $card-size
    margin-right -1px
    border-left 1px solid $cl-separator
    border-right @border-left
  }
}

:deep(.slider__nav) {
  @extends .app-gutter
  position absolute
  top -40px
  right 0
  z-index 10

  +size(L) {
    top -80px
  }
}

.related {
  position relative
  border-top 1px solid $cl-separator
  border-bottom @border-top
  margin-bottom -1px
}

.related__slider {
  width 100%

  margin-left auto
  margin-right auto

  +size(L) {
    max-width $card-size * 3 + 1

    &--count-1 {
      max-width $card-size
    }

    &--count-2 {
      max-width $card-size * 2
    }
  }
}

.related__nav--left {
  margin-right 13px

  +size(L) {
    margin-right 20px
  }
}

.related__nav--right {
  margin-left 13px

  +size(L) {
    margin-left 20px
  }
}

.related__nav {
  opacity 0
}

.related__nav--enabled {
  opacity 1
}

.related__card {
  box-sizing border-box
  padding 75px 50px
  height 100%
}
</style>
